
import React, { useState } from "react";
import BoxButton from "./BoxButton";
import "./Box.css";

const Box = ({ inquiry, onDelete, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedInquiry, setEditedInquiry] = useState({ ...inquiry });
  const [isExpanded, setIsExpanded] = useState(false); // expand/collapse state

  const handleChange = (e) => {
    setEditedInquiry({
      ...editedInquiry,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    onSave(editedInquiry);
    setIsEditing(false);
  };

  const isNewInquiry = () => {
    if (!inquiry.created_at) return false;
    const createdTime = new Date(inquiry.created_at).getTime();
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000; 
    return now - createdTime < oneDay;
  };

  return (
    <div className={`box-card ${isNewInquiry() ? "new-inquiry" : ""}`}>
      {isEditing ? (
        <>
          <input
            type="text"
            name="first_name"
            value={editedInquiry.first_name}
            onChange={handleChange}
            placeholder="First Name"
          />
          <input
            type="text"
            name="last_name"
            value={editedInquiry.last_name}
            onChange={handleChange}
            placeholder="Last Name"
          />
          <input
            type="text"
            name="company"
            value={editedInquiry.company}
            onChange={handleChange}
            placeholder="Company"
          />
          <input
            type="text"
            name="service"
            value={editedInquiry.service}
            onChange={handleChange}
            placeholder="Service"
          />
          <input
            type="text"
            name="duration"
            value={editedInquiry.duration}
            onChange={handleChange}
            placeholder="Duration"
          />
          <input
            type="text"
            name="city"
            value={editedInquiry.city}
            onChange={handleChange}
            placeholder="City"
          />
          <input
            type="text"
            name="state"
            value={editedInquiry.state}
            onChange={handleChange}
            placeholder="State"
          />
          <input
            type="text"
            name="country"
            value={editedInquiry.country}
            onChange={handleChange}
            placeholder="Country"
          />
          <input
            type="text"
            name="email"
            value={editedInquiry.email}
            onChange={handleChange}
            placeholder="Email"
          />
          <input
            type="text"
            name="phone"
            value={editedInquiry.phone}
            onChange={handleChange}
            placeholder="Phone"
          />
          <textarea
            name="additional_info"
            placeholder="Additional Info"
            value={editedInquiry.additional_info || ""}
            onChange={handleChange}
          />
          <div className="box-buttons">
            <BoxButton type="save" onClick={handleSave} />
            <BoxButton type="cancel" onClick={() => setIsEditing(false)} />
          </div>
        </>
      ) : (
        <>
          <h4>
            {inquiry.first_name} {inquiry.last_name}
          </h4>
          <p>
            <strong>Company:</strong> {inquiry.company}
          </p>
          <p>
            <strong>Service:</strong> {inquiry.service} ({inquiry.duration})
          </p>

          {/* Always visible info */}
          {isExpanded && (
            <>
              <p>
                <strong>Location:</strong> {inquiry.city}, {inquiry.state},{" "}
                {inquiry.country}
              </p>
              <p>
                <strong>Email:</strong> {inquiry.email}
              </p>
              <p>
                <strong>Phone:</strong> {inquiry.phone}
              </p>
              {inquiry.additional_info && (
                <p>
                  <strong>Additional Info:</strong> {inquiry.additional_info}
                </p>
              )}
              <p className="ci-consent">
                <strong>Consent:</strong> {inquiry.consent ? " Yes" : " No"}
              </p>
              <small>Created At: {inquiry.created_at}</small>
            </>
          )}

          <div className="box-buttons">
            <BoxButton 
  type="expand" 
  expanded={isExpanded} 
  onClick={() => setIsExpanded(!isExpanded)} 
/>
            <BoxButton type="edit" onClick={() => setIsEditing(true)} />
            <BoxButton type="view" inquiry={inquiry} />
            <BoxButton type="delete" onClick={() => onDelete(inquiry.id)} />
          </div>
        </>
      )}
    </div>
  );
};

export default Box;
